import _ from 'lodash';
import { notify } from '@/js/utils';
import md5 from 'js-md5';
import {
    SELECCIONA_OFERTA,
    TIPO_SIM,
    PORTABILIDAD,
    DIRECCION_ENVIO,
    ACCESO_CUENTA,
    METODO_DE_PAGO,
    // PROCESANDO_COMPRA,
    RESUMEN_COMPRA,
    // RESULTADO_COMPRA
} from './contrataConst';
import direccionEnvio from './direccionEnvioArchetype';

const URI = 'contrata-ahora',
    generalTitle = "¡Contrata ahora!",
    purchaseTypes = [
        { key: 'portability', label: 'Quiero portar mi línea', hint: 'Para obtener tu NIP de portabilidad llama al 051 desde el número que deseas portar.' },
        { key: 'nirChange', label: 'Deseo número nuevo', hint: 'Selecciona la zona del número nuevo que deseas', desc: 'Tu número iniciará con el dígito correspondiente a esa zona o región.\nEjemplo: Zona 5 → 55-XXXXXXX' },
        { key: 'newLine', label: 'Mantendré el número asignado automáticamente', hint: 'Siempre podrás ajustar tu línea en: Mi Cuenta → Mis números BlackFon®' },
    ],
    contrataYa = {
        step: null,
        numberOfLines: 1,
        selectedOffer: null,
        portNumber: null, // DEPRECATED
        purchaseType: null, // ['portability', 'newLine', 'nirChange'],
        numberToPort: null, // Número de Identificación Personal para portabilidad
        nip: null, // Número de Identificación Personal para portabilidad
        lada: null, // Código de área para número nuevo (NIR)
        zone: null, // Número de zona para cambio
        selectedPM: null,
        deliveryFormat: null,
        deviceCompatibilityConfirmed: false,
        pu: 0,
        intentId: null,
        intentHash: null
    };

let workingData = _.cloneDeep(contrataYa);

function checkNumberOfLines() {
    if (workingData.numberOfLines > 1)
        workingData.purchaseType = 'newLine';
}
function setNewIntent() {
    const timestamp = new Date().toISOString();
    workingData.intentId = 'intent-' + timestamp;
    workingData.intentHash = md5(workingData.intentId + '2039$');
}

const validate = (step) => {
    try {
        switch (step) {
            case SELECCIONA_OFERTA:
                if (workingData.selectedOffer === null)
                    throw 'Debes seleccionar una oferta';
                break;
            case TIPO_SIM:
                if (workingData.deliveryFormat === null)
                    throw 'Debes seleccionar un formato de entrega';
                if (workingData.deliveryFormat === 'physical')
                    direccionEnvio.validateAddress();
                else if (!workingData.deviceCompatibilityConfirmed)
                    throw 'Debes confirmar la compatibilidad de tu dispositivo';
                // valid = workingData.selectedOffer !== null;
                checkNumberOfLines();
                break;
            case PORTABILIDAD:
                checkNumberOfLines();
                switch (workingData.purchaseType) {
                    case 'portability':
                        if (!workingData.numberToPort)
                            throw 'Debes ingresar el número a portar';
                        if (!workingData.nip)
                            throw 'Debes ingresar el NIP de portabilidad';
                        break;
                    case 'nirChange':
                        if (!workingData.zone)
                            throw 'Debes especificar el número de zona';
                        break;
                    case 'newLine':
                        // nothing to validate
                        break
                    default:
                        throw 'Debes seleccionar una opción';
                        break;
                }
                // valid = workingData.selectedPM !== null;
                break;
            case DIRECCION_ENVIO:
                direccionEnvio.validateAddress();
                // valid = workingData.deliveryFormat !== null;
                break;
            case ACCESO_CUENTA:
                // valid = workingData.deviceCompatibilityConfirmed;
                break;
            case METODO_DE_PAGO:
                if (!workingData.selectedPM)
                    throw 'Debes seleccionar un método de pago válido';
                // throw 'error test';
                // valid = workingData.deviceCompatibilityConfirmed;
                break;
            case RESUMEN_COMPRA:
                if (!workingData.selectedPM)
                    throw 'Debes seleccionar un método de pago válido';
                setNewIntent()
                // throw 'error test';
                // valid = workingData.deviceCompatibilityConfirmed;
                break;
        }
        return true;
    } catch (e) {
        console.warn('Error en validación de datos', step, e, workingData);
        notify(e, 'warning');
        return false
    }
},
    clean = () => {
        workingData = _.cloneDeep(contrataYa);
    };

export default {
    URI,
    generalTitle,
    purchaseTypes,
    workingData,
    contrataYa,
    validate,
    clean
}